import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1 {...{
      "id": "inleiding",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#inleiding",
        "aria-label": "inleiding permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Inleiding`}</h1>
<p>{`Door middel van de API is het mogelijk om een koppeling te maken met Offsys.`}</p>
<br />
<h2 {...{
      "id": "starten",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#starten",
        "aria-label": "starten permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Starten`}</h2>
<p>{`Voor elke aanvraag is een API key nodig. De key staat in Offsys onder layouts. Open de layout die je wilt gebruiken en kopieer de key. Stuur de key mee in de header Authorization.`}</p>
<br />
<p><strong parentName="p">{` Voorbeeld: `}</strong></p>
<pre><code parentName="pre" {...{}}>{`curl "https://api.offsys.nl/products" \\
-X GET \\
-H "Authorization: 37d37675-59cd-431c-8d28-9553de7bae4d"
`}</code></pre>
<p>{`Een key hoort bij één layout. Orders die je aanmaakt krijgen die layout. Je ziet alleen de orders en statistieken van die layout.`}</p>
<br />
<h2 {...{
      "id": "antwoorden-en-fouten",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#antwoorden-en-fouten",
        "aria-label": "antwoorden en fouten permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Antwoorden en fouten`}</h2>
<p>{`Elk antwoord heeft een veld status: success of error. Bij error staat in message wat er mis is.`}</p>
<pre><code parentName="pre" {...{}}>{`{
    "status": "error",
    "message": "date doesn't have a (valid) value"
}
`}</code></pre>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Code`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Betekenis`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`200`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Gelukt`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Het filter of de sortering is ongeldig`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`401`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Er is geen of een ongeldige API key meegestuurd`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`404`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`De order, klant of het product bestaat niet`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`422`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Een veld ontbreekt of heeft een ongeldige waarde. In message staat om welk veld het gaat`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`500`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Er ging iets mis in Offsys`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`502`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`De mail kon niet naar alle ontvangers verstuurd worden, zie `}<a parentName="td" {...{
              "href": "/orders#mailen"
            }}>{`mailen`}</a></td>
</tr>
</tbody>
</table>
<br />
<h2 {...{
      "id": "paginas",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#paginas",
        "aria-label": "paginas permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Pagina's`}</h2>
<p>{`Orders, producten, productgroepen, klanten en beschikbaarheid komen per pagina terug. Onder meta staat hoeveel resultaten en pagina's er zijn.`}</p>
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": null
          }}>{`Veld`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Standaard`}</th>
<th parentName="tr" {...{
            "align": null
          }}>{`Omschrijving`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`page`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`1`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Welke pagina je wilt ophalen`}</td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": null
          }}>{`per_page`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`100`}</td>
<td parentName="tr" {...{
            "align": null
          }}>{`Aantal resultaten per pagina, maximaal 500`}</td>
</tr>
</tbody>
</table>
<pre><code parentName="pre" {...{}}>{`"meta": {
    "total": 248,
    "per_page": 100,
    "current_page": 1,
    "last_page": 3
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      